export default {
    auth: '/auth',
    faq: '/faq',
    form: '/form',
    home: '/',
    login: '/login',
    new_password: '/new-password',
    privacy_policy:
        'https://reservify-resources.s3.eu-central-1.amazonaws.com/draid-terms/privacy-draid.pdf',
    profile: '/profile',
    record: '/record',
    reset_password: '/reset-password',
    service_rules:
        'https://reservify-resources.s3.eu-central-1.amazonaws.com/draid-terms/terms_draid.pdf',
    sign_up: '/sign-up',
};
